(function ($) {
    $(function () {
        // make sure filters and search are cleared
        $("#profile-filter-kw").val("");
        $("#profile-filter-school, #profile-filter-dept").val("select");

        // custom select boxes
        $('.profile-filter select').selectric(
            {
                responsive: true,
                arrowButtonMarkup: "<span class='button'></span>",
                disableOnMobile: true
            }
        );

        // bind input enter click
        var keywordEnterClick = function (input) {
            $(document).on("keypress", input, function (e) {
                if (e.which == 13) {
                    var filterUrl = getDirectoryFilter(1);
                    updateDirectory(filterUrl);
                }
            });
        }
        keywordEnterClick("#profile-filter-kw");

        // bind page click event
        var pageClick = function (page) {
            $(document).on("click", page, function () {
                var filterUrl = getDirectoryFilter($(this).attr("data-dir-page"));
                updateDirectory(filterUrl);
            });
        };
        pageClick("#profile-results-container .pager a");

        // bind search click event
        var searchClick = function (button) {
            $(document).on("click", button, function () {
                var filterUrl = getDirectoryFilter(1);
                updateDirectory(filterUrl);
            });
        };
        searchClick("#profile-filter-submit");

        // build filter url
        var getDirectoryFilter = function getDirectoryFilter(requestedPage) {
            var baseUrl = $("#profile-filter > #FilterBaseUrl").val();
            var itemId = $("#profile-filter > #ItemId").val();
            var department = $("#profile-filter-dept").val();
            var school = $("#profile-filter-school").val();
            var keyword = $("#profile-filter-kw").val();

            return filterUrl = baseUrl + "?itemid=" + itemId + "&keyword=" + encodeURIComponent(keyword) + "&department=" + encodeURIComponent(department) + "&school=" + encodeURIComponent(school) + "&pageRequested=" + requestedPage;
        }

        // get and set data from filter
        var updateDirectory = function updateDirectory(url) {
            $.ajax({
                url: url,
                success: function (result) {
                    // insert result markup
                    $("#profile-results-container").html(result);

                    // responsive magic
                    $("#profile-results").footable({ breakpoints: { tablet: 750 } });

                    // scroll to top of component
                    scrollToEl("#profile-filter");

                    // refresh left nav sticky size calculation by triggering window resize event.
                    $(window).trigger("resize");

                }
            });
        }
    })
})($JQ);

var scrollToEl = function (el, spacing) {
    // set default spacing to 0
    var spacing = spacing || 20;

    if ($JQ(el).length) {
        var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (viewportWidth >= 960) {
            // calculate height of "sticky" elements
            var extra = $JQ('#header').outerHeight(true);
        }
        else {
            extra = 0;
        }

        $JQ('html, body').animate({
            // 20 is extra spacing away from sticky nav
            scrollTop: $JQ(el).offset().top - extra - spacing
        }, 600)
    }
};